import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/operation_management',
  component: Layout,
  name: 'operationManagement',
  meta: {
    title: '运营管理',
    icon: 'i-ant-design:appstore-outlined',
  },
  children: [
    {
      path: 'order_list',
      name: 'operationManagementOrderList',
      component: () => import('@/views/operation_management/order_list/index.vue'),
      meta: {
        title: 'Mind AI 订单列表',
        icon: 'i-ant-design:unordered-list-outlined',
      },
    },
    {
      path: 'activity_list',
      name: 'operationManagementActivityList',
      component: () => import('@/views/operation_management/activity_list.vue'),
      meta: {
        title: '活动列表',
        icon: 'i-ant-design:calendar-outlined',
      },
    },
  ],
}

export default routes
